import Link from "next/link";

import formStyles from "../FormStyles/forms.module.css";

const eServicesString = "E-tjänster för arbetsgivare";

const formData = {
  subjects: {
    defaultContactForm: [
      { id: 1, name: "Sjukdom", value: "Sjukdom" },
      { id: 2, name: "Arbetsskada", value: "Arbetsskada" },
      { id: 5, name: "Arbetsbrist", value: "Arbetsbrist" },
      { id: 3, name: "Dödsfall", value: "Dödsfall" },
      { id: 4, name: "Föräldraledighet", value: "Föräldraledighet" },
      { id: 6, name: "IA-systemet", value: "IA-systemet" },
      { id: 7, name: "Annat", value: "Annat" },
    ],
    eServicesContactForm: [{ id: 1, name: eServicesString, value: eServicesString }],
  },
  caseTypeInitValue: {
    defaultContactForm: "",
    eServicesContactForm: eServicesString,
  },
  messageInputFieldDescription: {
    defaultContactForm: (
      <>
        Om du har frågor om ett försäkringsärende måste du ringa kundtjänst{" "}
        <Link
          href={"tel:+46771880099"}
          style={{ color: "#020678" }}
          className={formStyles.descriptionTextLink}
        >
          0771-88 00 99
        </Link>
        . Sådana frågor får inte skickas eller besvaras via e-post.
      </>
    ),
    eServicesContactForm:
      "Skriv inte personnummer eller andra känsliga uppgifter om till exempel hälsa här.",
  },
  showSubjectInputField: {
    defaultContactForm: true,
    eServicesContactForm: false,
  },
  phoneNumberHref: {
    defaultContactForm: "tel:+46771880099",
    eServicesContactForm: "tel:086964949",
  },
  phoneNumber: {
    defaultContactForm: "0771-88 00 99",
    eServicesContactForm: "08-696 49 49",
  },
};

export { formData };
